




























































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import moment from 'moment';
import ICalendar from '@/components/icons/ICalendar.vue'

@Component({
  name: "DatePickerWithTime",
  components: {
    'i-calendar': ICalendar,
  }
})
export default class DatePickerWithTime extends Vue {

  @Prop({type: String || Number, default: ''}) dateInput !: any
  @Prop({type: String, default: ''}) height !: any
  @Prop({type: String, default: ''}) min !: any
  @Prop({type: String, default: ''}) max !: any
  @Prop({type: String, default: ''}) placeholder!: any

  mounted() {
    if(this.dateInput) {
      this.dateModel = moment.unix(this.dateInput).format("YYYY-MM-DD")
      this.timeModel = new Date(this.dateInput * 1000).getHours() + ":" + new Date(this.dateInput * 1000).getMinutes()
      this.displayDate = this.formatDate(this.dateModel, this.timeModel)
      this.onUpdateDate()
    }
  }

  @Watch('dateInput')
  getDateInput(NewVal: any) {
    if(NewVal) {
      this.dateModel = moment.unix(NewVal).format("YYYY-MM-DD")
      this.timeModel = new Date(NewVal * 1000).getHours() + ":" + new Date(NewVal * 1000).getMinutes()
    } else {
      let date = Math.floor((+ new Date()) / 1000)
      this.dateModel = moment.unix(date).format("YYYY-MM-DD")
      this.timeModel = new Date(date * 1000).getHours() + ":" + new Date(date * 1000).getMinutes()
    }
    if(this.dateInput == '') {
      this.displayDate = ''
    } else {
      this.displayDate = this.formatDate(this.dateModel, this.timeModel)
    }
  }
  get lang(){
    return localStorage.getItem('locale') || 'ru'
  }

  dropdownOpen: boolean = false
  pickerDate: string = ''
  meridiam: string = 'AM'

  dateModel: string = ''

  timeModel: string = new Date(this.dateInput * 1000).getHours() + ":" + new Date(this.dateInput * 1000).getMinutes()
  displayDate: string = this.formatDate(this.dateModel, this.timeModel)

  formatDate(date: any, time: any) {
    if (!date) return '';
    const timeI = time.split(':')
    const [year, month, day] = date.split('-')
    let monthName = parseInt(month)
    return ` ${day.length < 2 ? '0'+day : day}.${monthName <10 ? '0'+monthName:monthName  }.${year}
    ${timeI[0].length<2 ? '0'+timeI[0] : timeI[0]}:${timeI[1].length<2 ? '0'+timeI[1] : timeI[1]} `;
  }

  confirm() {
    this.dropdownOpen = false
    this.onUpdateDate();
  }

  onUpdateDate() {
    if (!this.dateModel || !this.timeModel) return false;
    this.displayDate = this.formatDate(this.dateModel, this.timeModel)
    this.$emit('getDate', this.dateModel + ' ' + this.timeModel);
  }


}
